module.exports = "<div id=\"homePrompt\">\n  <h4 class=\"mat-subheading-1\" *ngIf=\"auth.isAuthenticated()\">\n    You are logged in! Click <b>Dashboard</b> link from menu bar\n  </h4>\n\n  <h4 class=\"mat-subheading-1\" *ngIf=\"!auth.isAuthenticated()\">\n    You are not logged in! Please <a (click)=\"auth.login()\">Log In</a> to view dashboard.\n  </h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main